<template>
  <a-drawer width="40%" :label-col="4" :wrapper-col="20" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="发布人类型" prop="publisherType">
        <a-select v-model="form.publisherType" placeholder="请选择发布人类型" :disabled="isEdit" @change="handlePublisherTypeChange">
          <a-select-option :value="1">医院</a-select-option>
          <a-select-option :value="2">科室</a-select-option>
          <a-select-option :value="3">医师</a-select-option>
          <a-select-option :value="4">平台</a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- ==================== 医院选择（发布人类型=1） ==================== -->
      <a-form-model-item label="发布人" prop="publisher" v-if="form.publisherType == 1">
        <a-input-search
          v-model="publisherName"
          placeholder="请选择医院"
          enter-button="选择"
          @search="openDialog('hospital')"
          :readonly="true"
          :disabled="isEdit"
        />
        <table-select-modal
          ref="hospitalDialog"
          :visible.sync="hospitalSelectVisible"
          title="选择医院"
          :api-method="pageHospital"
          :columns="hospitalColumns"
          search-label="医院名称"
          search-key="hospitalName"
          search-placeholder="请输入医院名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          :z-index="1010"
          @ok="handleHospitalSelected"
          :width="1200"
        />
      </a-form-model-item>

      <!-- ==================== 科室选择（发布人类型=2） ==================== -->
      <a-form-model-item label="发布人" prop="publisher" v-if="form.publisherType == 2">
        <a-input-search
          v-model="publisherName"
          placeholder="请选择科室"
          enter-button="选择"
          @search="openDialog('depart')"
          :readonly="true"
          :disabled="isEdit"
        />
        <table-select-modal
          ref="departDialog"
          :visible.sync="departSelectVisible"
          title="选择科室"
          :api-method="pageDepart"
          :columns="departColumns"
          search-label="科室名称"
          search-key="name"
          search-placeholder="请输入科室名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          :query-params="departDialogParams"
          :z-index="1010"
          :search-col-span="11"
          @ok="handleDepartSelected"
          :width="1200"
        >
          <!-- 弹窗内 - 医院筛选（使用弹窗选择） -->
          <template #searchFields>
            <a-col :md="7" :sm="24">
              <a-form-item label="医院">
                <a-input-search
                  v-model="departFilterHospitalName"
                  placeholder="按医院筛选"
                  enter-button="选择"
                  @search="openFilterHospital('depart')"
                  :readonly="true"
                  allow-clear
                  @change="onClearDepartFilterHospital"
                />
              </a-form-item>
            </a-col>
          </template>
        </table-select-modal>
      </a-form-model-item>

      <!-- ==================== 医师选择（发布人类型=3） ==================== -->
      <a-form-model-item label="发布人" prop="publisher" v-if="form.publisherType == 3">
        <a-input-search
          v-model="publisherName"
          placeholder="请选择医师"
          enter-button="选择"
          @search="openDialog('doctor')"
          :readonly="true"
          :disabled="isEdit"
        />
        <table-select-modal
          ref="doctorDialog"
          :visible.sync="doctorSelectVisible"
          title="选择医师"
          :api-method="pageDoctor"
          :columns="doctorColumns"
          search-label="医师姓名"
          search-key="name"
          search-placeholder="请输入医师姓名"
          :data-path="'data.records'"
          :total-path="'data.total'"
          :query-params="doctorDialogParams"
          :z-index="1010"
          :search-col-span="6"
          @ok="handleDoctorSelected"
          :width="1200"
        >
          <!-- 弹窗内 - 医院+科室筛选（均使用弹窗选择） -->
          <template #searchFields>
            <a-col :md="6" :sm="24">
              <a-form-item label="医院">
                <a-input-search
                  v-model="doctorFilterHospitalName"
                  placeholder="按医院筛选"
                  enter-button="选择"
                  @search="openFilterHospital('doctor')"
                  :readonly="true"
                  allow-clear
                  @change="onClearDoctorFilterHospital"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="科室">
                <a-input-search
                  v-model="doctorFilterDepartName"
                  placeholder="按科室筛选"
                  enter-button="选择"
                  @search="openFilterDepart"
                  :readonly="true"
                  :disabled="!doctorFilterHospitalId"
                  allow-clear
                  @change="onClearDoctorFilterDepart"
                />
              </a-form-item>
            </a-col>
          </template>
        </table-select-modal>
      </a-form-model-item>

      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入视频标题" />
      </a-form-model-item>
      <a-form-model-item label="描述" prop="content">
        <a-input v-model="form.content" type="textarea" :rows="10" :auto-size="{ minRows: 10, maxRows: 30 }" placeholder="请输入视频描述" />
      </a-form-model-item>
      <a-form-model-item label="视频封面" prop="imageArr">
        <file-upload type="image" :defaultList="coverArr" :count="1"
                     @input="getCover($event)" />
        <span style="color: #999;font-size: 12px;">建议上传封面图片</span>
      </a-form-model-item>
      <a-form-model-item label="视频" prop="videoUrl">
        <file-upload type="video" :defaultList="form.videoArr" :count="1"
                     :disabled="isEdit"
                     @input="getVideo($event)" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

    <!-- ==================== 筛选弹窗（放在 drawer 根级别，避免嵌套 modal；z-index 高于主弹窗） ==================== -->
    <!-- 科室弹窗 - 医院筛选弹窗 -->
    <table-select-modal
      ref="departFilterHospitalDialog"
      :visible.sync="departFilterHospitalSelectVisible"
      title="按医院筛选"
      :api-method="pageHospital"
      :columns="filterHospitalColumns"
      search-label="医院名称"
      search-key="hospitalName"
      search-placeholder="请输入医院名称"
      :data-path="'data.records'"
      :total-path="'data.total'"
      :z-index="1020"
      @ok="handleDepartFilterHospitalSelected"
    />
    <!-- 医师弹窗 - 医院筛选弹窗 -->
    <table-select-modal
      ref="doctorFilterHospitalDialog"
      :visible.sync="doctorFilterHospitalSelectVisible"
      title="按医院筛选"
      :api-method="pageHospital"
      :columns="filterHospitalColumns"
      search-label="医院名称"
      search-key="hospitalName"
      search-placeholder="请输入医院名称"
      :data-path="'data.records'"
      :total-path="'data.total'"
      :z-index="1020"
      @ok="handleDoctorFilterHospitalSelected"
    />
    <!-- 医师弹窗 - 科室筛选弹窗 -->
    <table-select-modal
      ref="doctorFilterDepartDialog"
      :visible.sync="doctorFilterDepartSelectVisible"
      title="按科室筛选"
      :api-method="pageDepart"
      :columns="departColumns"
      search-label="科室名称"
      search-key="name"
      search-placeholder="请输入科室名称"
      :data-path="'data.records'"
      :total-path="'data.total'"
      :query-params="doctorFilterDepartParams"
      :z-index="1020"
      @ok="handleDoctorFilterDepartSelected"
    />
  </a-drawer>
</template>

<script>
import { addArticle, updateArticle, getArticle } from '@/api/article/article'
import { pageHospital } from '@/api/hospital/hospital'
import { pageDepart } from '@/api/hospital/depart'
import { pageDoctor } from '@/api/doctor/doctor'
import FileUpload from '@/components/FileUpload'
import TableSelectModal from '@/components/TableSelectModal'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'VideoUploadForm',
  components: {
    FileUpload,
    TableSelectModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '上传视频',
      open: false,
      // 视频封面预览列表
      coverArr: [],

      // 主选择弹窗控制
      hospitalSelectVisible: false,
      departSelectVisible: false,
      doctorSelectVisible: false,

      // 选中的发布人显示名称
      publisherName: '',

      // ----- 筛选弹窗控制 -----
      departFilterHospitalSelectVisible: false,   // 科室弹窗 - 医院筛选弹窗
      doctorFilterHospitalSelectVisible: false,   // 医师弹窗 - 医院筛选弹窗
      doctorFilterDepartSelectVisible: false,     // 医师弹窗 - 科室筛选弹窗

      // ----- 筛选条件值 -----
      departFilterHospitalId: undefined,
      departFilterHospitalName: '',
      doctorFilterHospitalId: undefined,
      doctorFilterHospitalName: '',
      doctorFilterDepartId: undefined,
      doctorFilterDepartName: '',

      // 表单参数
      form: {
        id: null,
        publisher: null,
        publisherName: null,
        publisherType: null,
        type: 2,
        title: null,
        content: null,
        imageArr: null,
        videoUrl: null,
        videoArr: [],
        videoCover: null,
        status: 0,
        rejectReason: null
      },
      rules: {
        publisherType: [
          { required: true, message: '发布人类型不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        videoUrl: [
          { required: true, message: '视频不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // 是否为编辑模式（编辑已审核通过的视频时，部分字段不可修改）
    isEdit () {
      return this.form.id !== null && this.form.id !== undefined
    },
    hospitalColumns() {
      return [
        { title: '医院名称', dataIndex: 'hospitalName', ellipsis: true, width: 200 },
        { title: '地区', dataIndex: 'areaName', width: 150 },
        { title: '医院等级', dataIndex: 'level', width: 100 },
        { title: '医院性质', dataIndex: 'nature', width: 100 },
        { title: '医院类型', dataIndex: 'type', width: 100 }
      ]
    },
    // 筛选弹窗用的医院列（精简版）
    filterHospitalColumns() {
      return [
        { title: '医院名称', dataIndex: 'hospitalName', ellipsis: true, width: 200 },
        { title: '地区', dataIndex: 'areaName', width: 150 },
        { title: '医院等级', dataIndex: 'level', width: 100 }
      ]
    },
    departColumns() {
      return [
        { title: '科室名称', dataIndex: 'name', ellipsis: true, width: 200 },
        { title: '所属医院', dataIndex: 'hospitalName', width: 200 }
      ]
    },
    doctorColumns() {
      return [
        { title: '医师姓名', dataIndex: 'name', ellipsis: true, width: 150 },
        { title: '所属医院', dataIndex: 'hospitalName', width: 200 },
        { title: '所属科室', dataIndex: 'departName', width: 150 },
        { title: '职称', dataIndex: 'professional', width: 100 }
      ]
    },
    // 科室选择弹窗 - 查询参数（按医院筛选）
    departDialogParams() {
      if (this.departFilterHospitalId) {
        return { hospitalId: this.departFilterHospitalId }
      }
      return {}
    },
    // 医师选择弹窗 - 查询参数（按医院+科室筛选）
    doctorDialogParams() {
      const params = {}
      if (this.doctorFilterHospitalId) {
        params.hospitalId = this.doctorFilterHospitalId
      }
      if (this.doctorFilterDepartId) {
        params.departId = this.doctorFilterDepartId
      }
      return params
    },
    // 医师弹窗内 - 科室筛选弹窗的查询参数（联动已选的医院）
    doctorFilterDepartParams() {
      if (this.doctorFilterHospitalId) {
        return { hospitalId: this.doctorFilterHospitalId }
      }
      return {}
    }
  },
  methods: {
    pageHospital,
    pageDepart,
    pageDoctor,

    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },

    // 发布人类型切换
    handlePublisherTypeChange () {
      this.form.publisher = null
      this.form.publisherName = null
      this.publisherName = ''
    },

    // 统一打开主选择弹窗
    openDialog (type) {
      if (type === 'hospital') {
        this.hospitalSelectVisible = true
      } else if (type === 'depart') {
        this.departSelectVisible = true
      } else if (type === 'doctor') {
        this.doctorSelectVisible = true
      }
    },

    // ==================== 筛选弹窗 - 医院 ====================
    openFilterHospital (type) {
      if (type === 'depart') {
        this.departFilterHospitalSelectVisible = true
      } else if (type === 'doctor') {
        this.doctorFilterHospitalSelectVisible = true
      }
    },
    handleDepartFilterHospitalSelected (hospital) {
      this.departFilterHospitalId = hospital.id
      this.departFilterHospitalName = hospital.hospitalName
      this.departFilterHospitalSelectVisible = false
    },
    handleDoctorFilterHospitalSelected (hospital) {
      this.doctorFilterHospitalId = hospital.id
      this.doctorFilterHospitalName = hospital.hospitalName
      // 医院变了，清空科室筛选
      this.doctorFilterDepartId = undefined
      this.doctorFilterDepartName = ''
      this.doctorFilterHospitalSelectVisible = false
    },
    // 清除科室弹窗的医院筛选
    onClearDepartFilterHospital (val) {
      const value = (val && val.target) ? val.target.value : val
      if (value === '' || value === undefined || value === null) {
        this.departFilterHospitalId = undefined
        this.departFilterHospitalName = ''
      }
    },
    // 清除医师弹窗的医院筛选
    onClearDoctorFilterHospital (val) {
      const value = (val && val.target) ? val.target.value : val
      if (value === '' || value === undefined || value === null) {
        this.doctorFilterHospitalId = undefined
        this.doctorFilterHospitalName = ''
        this.doctorFilterDepartId = undefined
        this.doctorFilterDepartName = ''
      }
    },

    // ==================== 筛选弹窗 - 科室 ====================
    openFilterDepart () {
      if (!this.doctorFilterHospitalId) return
      this.doctorFilterDepartSelectVisible = true
    },
    handleDoctorFilterDepartSelected (depart) {
      this.doctorFilterDepartId = depart.id
      this.doctorFilterDepartName = depart.name
      this.doctorFilterDepartSelectVisible = false
    },
    onClearDoctorFilterDepart (val) {
      const value = (val && val.target) ? val.target.value : val
      if (value === '' || value === undefined || value === null) {
        this.doctorFilterDepartId = undefined
        this.doctorFilterDepartName = ''
      }
    },

    // ==================== 主选择弹窗回调 ====================
    handleHospitalSelected (hospital) {
      this.form.publisher = hospital.id
      this.form.publisherName = hospital.hospitalName
      this.publisherName = hospital.hospitalName
      this.hospitalSelectVisible = false
    },
    handleDepartSelected (depart) {
      this.form.publisher = depart.id
      this.form.publisherName = depart.name
      this.publisherName = depart.name
      this.departSelectVisible = false
    },
    handleDoctorSelected (doctor) {
      this.form.publisher = doctor.id
      this.form.publisherName = doctor.name
      this.publisherName = doctor.name
      this.doctorSelectVisible = false
    },

    // ==================== 视频上传 ====================
    getVideo (info) {
      if (info.length === 0) {
        this.form.videoUrl = ''
        this.form.videoArr = []
        this.form.videoCover = ''
      } else {
        this.form.videoUrl = info[0].halfUrl
        this.form.videoArr = info
        // 回填视频封面：用 OSS 视频截帧生成封面图（相对路径，与 videoUrl 一致）
        this.form.videoCover = info[0].halfUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_800,m_fast'
      }
    },

    // ==================== 视频封面上传 ====================
    getCover (info) {
      if (info.length === 0) {
        this.form.imageArr = ''
        this.coverArr = []
      } else {
        this.form.imageArr = info.map(item => item.halfUrl).join(',')
        this.coverArr = info
      }
    },

    // ==================== 表单操作 ====================
    reset () {
      this.form = {
        id: null,
        publisher: null,
        publisherName: null,
        publisherType: null,
        type: 2,
        title: null,
        content: null,
        imageArr: null,
        videoUrl: null,
        videoArr: [],
        videoCover: null,
        status: 0,
        rejectReason: null
      }
      this.publisherName = ''
      this.coverArr = []
      // 重置筛选条件
      this.departFilterHospitalId = undefined
      this.departFilterHospitalName = ''
      this.doctorFilterHospitalId = undefined
      this.doctorFilterHospitalName = ''
      this.doctorFilterDepartId = undefined
      this.doctorFilterDepartName = ''
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },

    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '上传视频'
    },

    /** 编辑已审核通过的视频（仅修改文字与封面信息） */
    handleUpdate (record) {
      this.reset()
      this.open = true
      this.formTitle = '编辑视频'
      getArticle({ id: record.id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          publisher: data.publisher,
          publisherName: data.publisherName,
          publisherType: data.publisherType,
          type: data.type,
          title: data.title,
          content: data.content,
          imageArr: data.imageArr,
          videoUrl: data.videoUrl,
          videoArr: data.videoUrl ? [{ uid: '-1', status: 'done', halfUrl: data.videoUrl, url: processImageUrl(data.videoUrl) }] : [],
          videoCover: data.videoCover,
          status: data.status,
          rejectReason: data.rejectReason
        }
        this.publisherName = data.publisherName
        // 封面回填（补全 uid、status，url 用完整地址用于预览回显，halfUrl 用相对地址用于保存）
        if (data.imageArr) {
          this.coverArr = data.imageArr.split(',').map((url, index) => ({ uid: '-cover-' + index, status: 'done', halfUrl: url, url: processImageUrl(url) }))
        }
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },

    submitForm () {
      const isEdit = this.form.id !== null && this.form.id !== undefined
      // 编辑模式只修改文字与封面，发布人不可改，无需校验
      if (!isEdit && this.form.publisherType !== 4 && !this.form.publisher) {
        this.$message.warning('请选择发布人')
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const isEdit = this.form.id !== null && this.form.id !== undefined
          const request = isEdit ? updateArticle(this.form) : addArticle(this.form)
          request.then(response => {
            this.$message.success(isEdit ? '修改成功' : '上传成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
